import { InputAdornment, makeStyles, TextField } from "@material-ui/core";
import { useFormikContext } from "formik";
import React, { useRef, useState } from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },

  root: {
    "& .MuiOutlinedInput-input": {
      borderRadius: "4px",
      backgroundColor: "#f3f6f9",
    },

    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
    },

    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "purple",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "purple",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "purple",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "purple",
    },
    "& .MuiOutlinedInput-multiline": {
      backgroundColor: "#f3f6f9",
    },
  },

  secondaryLabel: {
    color: "#9d9db1",
    fontSize: "12px",
    fontWeight: 500,
  },

  title: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#000",
  },
  textField: {
    backgroundColor: "#f3f6f9",
  },
}));

const BrowseSoundFile = ({ formikValue, uploadMultiple }) => {
  const classes = useStyles();

  const [soundFiles, setsoundFiles] = useState([]);
  const onFileChange = (e) => {
    let filesArray = e.target.files;
    setsoundFiles(filesArray);
  };
  return (
    <div className="mt-7 ml-5">
      <div className="pb-3">
        <strong>Upload Sound</strong>
        <span className={`${classes.secondaryLabel} d-block pt-2`}>
          Only Mp3, and WAV format allowed
        </span>
      </div>
      <TextField
        id="soundFile"
        name="soundFile"
        variant="outlined"
        placeholder="Select Sound"
        margin="dense"
        fullWidth
        className={classes.root}
        onClick={e => (e.target.value = null)} 

        disabled
        classes={{ root: classes.textField }}
        InputProps={{
          style: { color: "currentcolor" },
          endAdornment: (
            <InputAdornment position="end">
              <label
                className={`${classes.title} btn`}
                style={{
                  color: "#2c3687",
                  margin: 0,
                }}
                htmlFor="browse-sound"
              >
                BROWSE
              </label>
            </InputAdornment>
          ),
        }}
        onChange={formikValue.handleChange}
        onBlur={formikValue.handleBlur}
        value={
          soundFiles.length > 1
            ? soundFiles.length + " files selected"
            : formikValue.values.soundFile &&
              formikValue.values.soundFile[0] &&
              formikValue.values.soundFile[0].name
        }
      />

      {formikValue.touched.soundFile && formikValue.errors.soundFile && (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">{formikValue.errors.soundFile}</div>
        </div>
      )}
      <input
        id="browse-sound"
        style={{ visibility: "hidden" }}
        type="file"
        accept="audio/mp3, audio/wav"
        multiple={uploadMultiple}
        onChange={(event) => {
          const files = event.target.files;
          if (files.length === 0) {
            formikValue.setFieldValue("soundFile", '');
          } else {
            onFileChange(event);
            formikValue.setFieldValue("soundFile", files);
          }
        }}
      />
    </div>
  );
};

export default BrowseSoundFile;
